import { createSlice } from "@reduxjs/toolkit";

// Helper function to restore selectedOrgCodes from localStorage
const getInitialSelectedOrgCodes = () => {
  try {
    const stored = localStorage.getItem("SELECTED_ORG_CODE");
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (err) {
    console.error("Error parsing SELECTED_ORG_CODE from localStorage:", err);
  }
  return [];
};

const orgSlice = createSlice({
  name: "org",
  initialState: {
    orgDetails: {},
    selectedOrgCodes: getInitialSelectedOrgCodes(),
    refreshKey: 0,
  },
  reducers: {
    setOrgDetails: (state, action) => {
      state.orgDetails = action.payload;
    },
    setSelectedOrgCode: (state, action) => {
      // keep backward-compatible single value setter (accept string or array)
      const payload = action.payload;
      if (Array.isArray(payload)) state.selectedOrgCodes = payload;
      else if (payload === "" || payload == null) state.selectedOrgCodes = [];
      else state.selectedOrgCodes = [payload];
    },
    toggleSelectedOrgCode: (state, action) => {
      const code = action.payload;
      if (!code) return;
      const idx = state.selectedOrgCodes.indexOf(code);
      if (idx === -1) state.selectedOrgCodes.push(code);
      else state.selectedOrgCodes.splice(idx, 1);
    },
    triggerRefresh: (state) => {
      state.refreshKey = (state.refreshKey || 0) + 1;
    },
  },
});
export const {
  setOrgDetails,
  setSelectedOrgCode,
  toggleSelectedOrgCode,
  triggerRefresh,
} = orgSlice.actions;
export default orgSlice.reducer;
